import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { SERVER_API_URL } from 'app/app.constants';
import { createRequestOption, Pagination } from 'app/shared/util/request-util';
import { IUser } from './user.model';
import { Authority } from 'app/shared/constants/authority.constants';
import { ChangePassword } from 'app/model/entity/change-password';
import { Constant } from 'app/config/constants';
import { DialogService } from 'app/service/dialog.service';
import { DialogMessageComponent } from 'app/dialog/dialog-message/dialog-message.component';
import { TranslateService } from '@ngx-translate/core';

import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UserService {
  public resourceUrl = SERVER_API_URL + 'services/uaa/api/users';
  mapEndPoint: Map<string, string> = new Map<string, string>();

  constructor(private http: HttpClient, private dialogService: DialogService, private translateService: TranslateService) {}

  /**
   * setEndPoint
   * @param endPoint
   */
  setEndPoint(endPoint: Map<string, string>) {
    this.mapEndPoint = endPoint;
  }

  create(user: IUser): Observable<IUser> {
    return this.http.post<IUser>(this.resourceUrl, user);
  }

  update(user: IUser): Observable<IUser> {
    return this.http.put<IUser>(this.resourceUrl, user);
  }

  find(login: string): Observable<IUser> {
    return this.http.get<IUser>(`${this.resourceUrl}/${login}`);
  }

  query(req?: Pagination): Observable<HttpResponse<IUser[]>> {
    const options = createRequestOption(req);
    return this.http.get<IUser[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(login: string): Observable<{}> {
    return this.http.delete(`${this.resourceUrl}/${login}`);
  }

  authorities(): Observable<string[]> {
    return of([Authority.ADMIN, Authority.USER]);
  }

  checkExistByUserId(user: IUser): Observable<IUser> {
    return this.http.post<IUser>(`${this.resourceUrl}/checkExistByUserId`, user);
  }
  changePassword(payload: any): Observable<string> {
    if (!this.mapEndPoint) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('ticket-editor.common-error')
        }
      });
      return throwError(() => new Error('No design environment'));
    }
    payload.urlAPI = `${this.mapEndPoint.get(Constant.NEW_API_URL_BASE)}/${this.mapEndPoint.get(
      Constant.NEW_API_URL_STAGE
    )}/cmp-api/update-password`;
    payload.authorization = `Bearer ${sessionStorage.getItem('id_token_cognito')}`;
    return this.http.post<string>(`${SERVER_API_URL}services/uaa/api/change-password`, payload);
  }
  checkConfirmCurrentPassword(changePassword: ChangePassword): Observable<string> {
    return this.http.post<string>(`${SERVER_API_URL}services/uaa/api/account/check-confirm-password`, changePassword);
  }

  /**
   * getEndPoint
   * @returns
   */
  getEndPoint(): Observable<Map<string, string>> {
    const ticketManagerUrl = Constant.BACKEND_URL + Constant.BID_SERVICE_URL + 'api/ticket-manager';
    return this.http.get<Map<string, string>>(`${ticketManagerUrl}/get-end-point-web-refund`);
  }
}
